import CustomTables from '../../../../components/CustomTable/CustomTables';
import { Column, ILazyParams } from '../../../../components/CustomTable/CustomTables';
import { Box, Flex, Text, Badge, Image, Grid, GridItem, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerCloseButton, DrawerBody, DrawerFooter, Select, useDisclosure, Button, FormControl, FormLabel, NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, } from '@chakra-ui/react';
import { useEffect, useState, useCallback } from 'react';
import MyDiv from './leavemanagement.style';
import { CustomButton, CustomToast } from '../../../../components';
import PlusIcon from '../../../../assets/images/Vector.svg';
import { useFetch } from '../../../../hooks/useFetch';
import { IBranchDropdown, ICompanyDropdown } from '../../Master/Branch/model';
import { IDepartment } from '../../Master/Department/model';
import { approvalType, IApprovalSetting } from './modal';

const LeaveManagement = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState<number | null>(null);
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [tableData, setTableData] = useState<IApprovalSetting[]>([]);
    const [totalRecords, setTotalRecords] = useState(0);

    const [lazyParams, setLazyParams] = useState<ILazyParams>({ first: 0, rows: 20, sortField: undefined, sortOrder: undefined, multiSortMeta: [], filters: {}, globalFilter: '', });
    const [formData, setFormData] = useState({ company: '', branch: '', department: '', teamLeadDays: '', managerDays: '', approval_Type: "" });
    const [approverDays, setApproverDays] = useState({ teamLead: 0, manager: 0, });
    const [companies, setCompanies] = useState<ICompanyDropdown[]>([]);
    const [branch, setBranch] = useState<IBranchDropdown[]>([]);
    const [department, setDepartment] = useState<IDepartment[]>([]);


    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (name === "company") {
            setFormData(prev => ({ ...prev, branch: "" }));
            setBranch([]);
            branchData(Number(value));
        }
    };

    const handleUpdate = async () => {
        const payload: IApprovalSetting = {
            company_Id: Number(formData.company),
            branch_Id: Number(formData.branch),
            department_Id: Number(formData.department),
            approval_Type: Number(formData.approval_Type),
            approvers: [
                { name: 'Team Lead', maxApprovalDays: approverDays.teamLead },
                { name: 'Manager', maxApprovalDays: approverDays.manager },
            ].filter(a => a.maxApprovalDays > 0)
        };

        let response;
        if (isEditMode && editId !== null) {
            response = await fetchApi(`ApprovalSettings`, "PUT", payload);
            if (response) {
                addToast({ message: "Updated successfully", status: "success" })
                loadLeaveApprovalSetting(lazyParams);
            }
        } else {
            response = await fetchApi("ApprovalSettings", "POST", payload, "", "");
            if (response) {
                addToast({ message: "Posted successfully", status: "success" })
                loadLeaveApprovalSetting(lazyParams);
            }
        }

        setFormData({ company: '', branch: '', department: '', teamLeadDays: '', managerDays: '', approval_Type: "" });
        setApproverDays({ teamLead: 0, manager: 0, });
        setEditId(null);
        setIsEditMode(false);
        onClose();
    };
    const handleAddNew = () => {
        setIsEditMode(false);
        setEditId(null);
        setFormData({ company: '', branch: '', department: '', teamLeadDays: '', managerDays: '', approval_Type: "" });
        setApproverDays({ teamLead: 0, manager: 0, });
        onOpen();
    };


    const handleEdit = (row: IApprovalSetting) => {
        setIsEditMode(true);
        setEditId(row.branch_Id);
        setFormData({
            company: String(row.company_Id),
            branch: String(row.branch_Id),
            department: String(row.department_Id),
            teamLeadDays: '',
            managerDays: '',
            approval_Type: String(row.approval_Type)
        });

        const approverMap: any = {};
        row.approvers.forEach(appr => {
            if (appr.name === 'Team Lead') approverMap.teamLead = appr.maxApprovalDays;
            if (appr.name === 'Manager') approverMap.manager = appr.maxApprovalDays;
        });

        setApproverDays({
            teamLead: approverMap.teamLead || 0,
            manager: approverMap.manager || 0,
        });

        branchData(row.company_Id);
        onOpen();
    };

    const loadLeaveApprovalSetting = useCallback(async (params: ILazyParams) => {
        const qs = new URLSearchParams();
        qs.set('first', String(params.first));
        qs.set('rows', String(params.rows));
        if (params.sortField) qs.set('sortField', params.sortField);
        if (params.sortOrder) qs.set('sortOrder', String(params.sortOrder));
        if (params.globalFilter) qs.set('globalFilter', params.globalFilter);
        if (params.filters && Object.keys(params.filters).length) {
            qs.set('filters', JSON.stringify(params.filters));
        }

        const response = await fetchApi(`ApprovalSettings?${qs.toString()}`, "GET");
        if (response) {
            const withLabel = (response.data || []).map((row: IApprovalSetting) => ({
                ...row,
                approvalTypeLabel: approvalType.find(a => a.value === row.approval_Type)?.label || '-',
            }));
            setTableData(withLabel);
            setTotalRecords(response.totalRecords ?? withLabel.length);
        }
    }, [fetchApi]);

    const company = async () => {
        const response = await fetchApi("Dropdown/company", "GET");
        if (response) {
            setCompanies(response);
        }
    }

    const branchData = async (companyID?: number) => {
        const response = await fetchApi("DropDown/branches", "GET", "", companyID ? `companyId=${companyID}` : null);
        if (response) {
            setBranch(response);
        }
    }

    const departmentData = async () => {
        const response = await fetchApi("DropDown/department", "GET");
        if (response) {
            setDepartment(response);
        }
    }

    useEffect(() => { loadLeaveApprovalSetting(lazyParams); }, [lazyParams]);
    useEffect(() => { company(); departmentData(); }, [])

    return (
        <MyDiv>
            <Box>
                <Flex justifyContent="space-between" alignItems="center" mb={4}>
                    <Text fontSize="2xl" fontWeight="bold"> Approval Setting</Text>
                    <CustomButton title="Add New" className="btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNew} />
                </Flex>
                <Box mt={3} p={3} borderRadius="md" bg="blue.50" border="1px solid" borderColor="blue.200" >
                    <Text fontSize="sm" color="blue.700">
                        <strong>Note:</strong> If a leave request exceeds the Manager's maximum approval days, it will automatically be forwarded to the <strong>Branch Head</strong> for approval.
                    </Text>
                </Box>
                <Box mt={4} overflowX="auto" borderRadius="md" boxShadow="sm" bg="#fff" p={2}>
                    <Grid className="grid_container">
                        <GridItem colSpan={12}>
                            {/* <CustomTables<IApprovalSetting & { approvalTypeLabel: string }>
                                value={tableData as any}
                                // headerColor="green"
                                borderColor="green"
                                loading={loading}
                                loadingSkeletonRows={10}
                                emptyMessage="No Data Available"
                                preferenceKey="leaveApprovalSettings"
                                showToolbar
                                globalSearchPlaceholder="Search approval settings..."
                                selectable='multiple'
                                lazy
                                lazyParams={lazyParams}
                                onLazyParamsChange={setLazyParams}
                                totalRecords={totalRecords}
                                showPagination
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                maxTableHeight={null}
                            > */}

                            <CustomTables<IApprovalSetting & { approvalTypeLabel: string }>
                                /* ---------- data + basic state ---------- */
                                value={tableData as any}                              // required: rows to render
                                loading={loading}                              // shows skeleton (first load) / dim overlay (refetch)
                                loadingSkeletonRows={10}                        // how many shimmer rows while first loading
                                emptyMessage="No Data Available"                // shown when value is empty

                                /* ---------- appearance ---------- */
                                headerColor="black"                             // header text color (default "Black")
                                maxTableHeight={null}                            // null = grow to fit all rows, no inner scroll
                                // or e.g. "600px" to cap height with scroll

                                /* ---------- toolbar (search + column chooser) ---------- */
                                showToolbar                                      // default true — set false to hide entirely
                                globalSearchPlaceholder="Search approval settings..."

                                /* ---------- persistence ---------- */
                                preferenceKey="leaveApprovalSettings"            // localStorage key: remembers filters/sort/
                                // frozen/hidden/widths/order per user

                                /* ---------- row selection ---------- */
                                // selectable="multiple"                            // "single" | "multiple" | omit to disable
                                // selectedRows={selectedRows}                      // controlled selection (optional)
                                // onSelectionChange={setSelectedRows}               // fires whenever checkboxes change
                                // rowKey={(row) => `${row.branch_Id}-${row.department_Id}-${row.approval_Type}`}
                                // REQUIRED whenever selectable/expandable is used —
                                // must uniquely identify a row

                                /* ---------- grouping ---------- */
                                // groupByField="company_Name"                      // collapsible group headers by this field
                                // (omit entirely if you don't want grouping)

                                /* ---------- row expansion ---------- */
                                // expandable                                        // adds an expand arrow per row
                                // rowExpansionTemplate={(row) => (
                                //     <Flex direction="column" gap={1} fontSize="sm">
                                //         <Text>Company ID: {row.company_Id}</Text>
                                //         <Text>Branch ID: {row.branch_Id}</Text>
                                //         <Text>Department ID: {row.department_Id}</Text>
                                //     </Flex>
                                // )}

                                /* ---------- server-driven (lazy) mode ---------- */
                                lazy                                               // turn off entirely for client-side filter/sort/search
                                lazyParams={lazyParams}                           // you own this state
                                onLazyParamsChange={setLazyParams}                // fires on sort/filter/search/page change -> refetch here
                                totalRecords={totalRecords}                       // server's total row count, drives pagination math

                                /* ---------- pagination ---------- */
                                showPagination                                    // default: on when lazy, off otherwise
                                rowsPerPageOptions={[20, 50, 100, 500]}
                                defaultRowsPerPage={20}                           // only matters in non-lazy mode
                            >

                                <Column header="S. No" body={(_, i) => lazyParams.first + i + 1} width={70} />
                                <Column header="Approval Type" field="approvalTypeLabel" sortable filterable filterType="select" />
                                <Column header="Company" field="company_Name" sortable filterable filterType="text" />
                                <Column header="Branch" field="branch_Name" sortable filterable filterType="text" />
                                <Column header="Department" field="department_Name" sortable filterable filterType="text" />
                                <Column header="Approvers" field="approvers"
                                    body={(row) => (
                                        <Flex gap={2} wrap="wrap">
                                            {row.approvers.map((approver: any, index: number) => (
                                                <Badge key={index} bg="green.400" color="white" px={3} py={1} borderRadius="md">
                                                    {approver.name} ({approver.maxApprovalDays} {approver.maxApprovalDays > 1 ? 'days' : 'day'})
                                                </Badge>
                                            ))}
                                        </Flex>
                                    )}
                                />
                                <Column header="Action" frozen="right" width={90}
                                    body={(row: IApprovalSetting) => (
                                        <Text className="font-poppins text_regular text_md" color="green" cursor="pointer" onClick={() => handleEdit(row)}>
                                            Edit
                                        </Text>
                                    )}
                                />
                            </CustomTables>
                        </GridItem>
                    </Grid>
                </Box>

                {/* Drawer */}
                <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
                    <DrawerOverlay />
                    <DrawerContent className="font-poppins text_md text_regular">
                        <DrawerCloseButton />
                        <DrawerHeader fontWeight="bold">{isEditMode ? 'Edit Approval' : 'Add  Approval '}</DrawerHeader>
                        <DrawerBody>
                            <Box py={2}>
                                <FormControl mt={1} isRequired>
                                    <FormLabel>Company Name</FormLabel>
                                    <Select placeholder="Select Aproval Type " name="approval_Type" onChange={handleChange} value={formData.approval_Type} >
                                        {approvalType.map(c => (<option key={c.value} value={c.value}>{c.label}</option>))}
                                    </Select>
                                </FormControl>
                                <FormControl mt={1} isRequired>
                                    <FormLabel>Company Name</FormLabel>
                                    <Select placeholder="Select Company" name="company" onChange={handleChange} value={formData.company} >
                                        {companies.map(c => (<option key={c.company_ID} value={c.company_ID}>{c.company_Name}</option>))}
                                    </Select>
                                </FormControl>

                                <FormControl mt={1} isRequired>
                                    <FormLabel>Branch Name</FormLabel>
                                    <Select placeholder="Select Branch" name="branch" onChange={handleChange} value={formData.branch} isDisabled={!branch.length}>
                                        {branch.map(b => (<option key={b.branch_Id} value={b.branch_Id}>{b.branchName}</option>))}
                                    </Select>
                                </FormControl>

                                <FormControl mt={1} isRequired>
                                    <FormLabel>Department Name</FormLabel>
                                    <Select placeholder="Select Department" name="department" onChange={handleChange} value={formData.department} isDisabled={!department.length}>
                                        {department.map(d => (<option key={d.id} value={d.id}>{d.departmentName}</option>))}
                                    </Select>
                                </FormControl>

                                <Text fontWeight="semibold" fontSize="md" py={5} >Approval Roles</Text>

                                <FormControl mt={1}>
                                    <FormLabel>Team Lead - Max Approval Days</FormLabel>
                                    <NumberInput min={0} max={30} value={approverDays.teamLead} onChange={(_, num) => setApproverDays(prev => ({ ...prev, teamLead: num }))} >
                                        <NumberInputField />
                                        <NumberInputStepper>
                                            <NumberIncrementStepper />
                                            <NumberDecrementStepper />
                                        </NumberInputStepper>
                                    </NumberInput>
                                </FormControl>

                                <FormControl mt={1}>
                                    <FormLabel>Manager- Max Approval Days</FormLabel>
                                    <NumberInput min={0} max={30} value={approverDays.manager} onChange={(_, num) => setApproverDays(prev => ({ ...prev, manager: num }))}>
                                        <NumberInputField />
                                        <NumberInputStepper>
                                            <NumberIncrementStepper />
                                            <NumberDecrementStepper />
                                        </NumberInputStepper>
                                    </NumberInput>
                                </FormControl>
                            </Box>
                        </DrawerBody>

                        <DrawerFooter>

                            <Button colorScheme="green" onClick={handleUpdate} className='font-poppins text_md text_medium ' mr={2}>
                                {isEditMode ? 'Update' : 'Add'}
                            </Button>
                        </DrawerFooter>
                    </DrawerContent>
                </Drawer>
            </Box>
        </MyDiv >
    );
};

export default LeaveManagement;